import { z } from 'zod';

export const ClientSchema = z.object({
  createdAt: z.object({
    seconds: z.number(),
    nanoseconds: z.number(),
  }),
  createdBy: z.string(),
  dateOfBirth: z.object({
    seconds: z.number(),
    nanoseconds: z.number(),
  }),
  displayName: z.string(),
  email: z.string(),
  firstName: z.string(),
  gender: z.string(),
  lastName: z.string(),
  orgId: z.string(),
  role: z.string(),
  status: z.string(),
  therapistId: z.string(),
  uid: z.string(),
});

export const EditClientSchema = z.object({
  email: z.string().email('Invalid email address'),
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
});

export type IClient = z.infer<typeof ClientSchema>;
